<template>
  <div class="wrapper">
    <div class="main-panel">
      <div class="main-content">
        <div class="content-wrapper">
          <div class="container-fluid">
            <section class="basic-elements">
              <div class="row">
                <div class="col-sm-12">
                  <a class="btn btn-secondary float-right top-back-button" @click.prevent="back()" v-if="currentRouteName == 'showPatient'"><i class="fa fa-arrow-left"></i></a>
                  <h2 class="content-header">{{ patient.name }}  {{ patient.surname }}</h2>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <ul class="nav nav-tabs" id="tabs">
                        <li class="nav-item">
                          <a class="nav-link active show" id="base-tabX0" data-toggle="tab" href="#tab0">{{ $t("labels.dashboard") }}</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" id="base-tabX9" data-toggle="tab" href="#tab9">{{ $t("labels.calendar") }}</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" id="base-tabX1" data-toggle="tab" href="#tab1">{{ $t("labels.patientData") }}</a>
                        </li>
                        <!--
                        <li class="nav-item">
                          <a class="nav-link" id="base-tabX2" data-toggle="tab" href="#tab2">{{ $t("labels.seizureCalendar") }}</a>
                        </li>
                        -->
                        <li class="nav-item">
                          <a class="nav-link" id="base-tabX3" data-toggle="tab" href="#tab3">{{ $t("models.therapy") }}</a>
                        </li>
                        <!--
                        <li class="nav-item">
                          <a class="nav-link" id="base-tabX4" data-toggle="tab" href="#tab4">{{ $t("labels.events") }}</a>
                        </li>
                        -->
                        <li class="nav-item">
                          <a class="nav-link" id="base-tabX5" data-toggle="tab" href="#tab5">{{ $t("labels.medicalExams") }}</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" id="base-tabX6" data-toggle="tab" href="#tab6">{{ $t("labels.archive") }}</a>
                        </li>
                        <!--
                        <li class="nav-item">
                          <a class="nav-link" id="base-tabX7" data-toggle="tab" href="#tab7">{{ $t("labels.appointmentCalendar") }}</a>
                        </li>
                        -->
                        <li class="nav-item">
                          <a class="nav-link" id="base-tabX8" data-toggle="tab" href="#tab8" @click="getGraphdata">{{ $t("labels.seizureGraph") }}</a>
                        </li>
                      </ul>
                      <div class="tab-content px-3">
                        <div role="tabpanel" class="tab-pane active show" id="tab0">
                          <div class="container-fluid" id="home-buttons-container">
                            <div class="row d-flex justify-content-around">
                              <div class="card" @click="rapidLinkTo('homePatient')">
                                <img src="/app-assets/img/home/dati-paziente.png" class="card-img-top">
                                <div class="card-body">
                                  <span class="card-text">{{ $t("labels.homePatient") }}</span>
                                </div>
                              </div>
                              <div class="card" @click="rapidLinkTo('homeSeizuresList')">
                                <img src="/app-assets/img/home/diario-crisi.png" class="card-img-top">
                                <div class="card-body">
                                  <span class="card-text">{{ $t("labels.homeSeizuresList") }}</span>
                                </div>
                              </div>
                              <div class="card" @click="rapidLinkTo('homeTherapy')">
                                <img src="/app-assets/img/home/terapia.png" class="card-img-top">
                                <div class="card-body">
                                  <span class="card-text">{{ $t("labels.homeTherapy") }}</span>
                                </div>
                              </div>
                              <div class="card" @click="rapidLinkTo('homeMedicalExams')">
                                <img src="/app-assets/img/home/esami-medici.png" class="card-img-top">
                                <div class="card-body">
                                  <span class="card-text">{{ $t("labels.homeMedicalExams") }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="row d-flex justify-content-around">
                              <div class="card" @click="rapidLinkTo('homePhotoAndVideo')">
                                <img src="/app-assets/img/home/foto-video.png" class="card-img-top">
                                <div class="card-body">
                                  <span class="card-text">{{ $t("labels.homePhotoAndVideo") }}</span>
                                </div>
                              </div>
                              <div class="card" @click="rapidLinkTo('homeSeizureGraphs')">
                                <img src="/app-assets/img/home/grafici.png" class="card-img-top">
                                <div class="card-body">
                                  <span class="card-text">{{ $t("labels.homeSeizureGraphs") }}</span>
                                </div>
                              </div>
                              <div class="card" @click="rapidLinkTo('homeCertificate')">
                                <img src="/app-assets/img/home/certificato.png" class="card-img-top">
                                <div class="card-body">
                                  <span class="card-text">{{ $t("labels.homeCertificate") }}</span>
                                </div>
                              </div>
                              <div class="card" @click="rapidLinkTo('homeCalendar')">
                                <img src="/app-assets/img/home/calendario.png" class="card-img-top">
                                <div class="card-body">
                                  <span class="card-text">{{ $t("labels.homeCalendar") }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="row d-flex justify-content-around">
                              <div class="card" @click="rapidLinkTo('homeTelephone')">
                                <img src="/app-assets/img/home/telefono.png" class="card-img-top">
                                <div class="card-body">
                                  <span class="card-text">{{ $t("labels.homeTelephone") }}</span>
                                </div>
                              </div>
                              <div class="card" @click="rapidLinkTo('homeArchives')">
                                <img src="/app-assets/img/home/archivio.png" class="card-img-top">
                                <div class="card-body">
                                  <span class="card-text">{{ $t("labels.homeArchives") }}</span>
                                </div>
                              </div>
                              <div class="card" @click="rapidLinkTo('homeNews')">
                                <img src="/app-assets/img/home/notizie.png" class="card-img-top">
                                <div class="card-body">
                                  <span class="card-text">{{ $t("labels.homeNews") }}</span>
                                </div>
                              </div>
                              <div class="card" @click="rapidLinkTo('homeInformation')">
                                <img src="/app-assets/img/home/informazioni.png" class="card-img-top">
                                <div class="card-body">
                                  <span class="card-text">{{ $t("labels.homeInformation") }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div role="tabpanel" class="tab-pane show" id="tab9">
                          <UnifiedCalendar 
                            :bus="this"
                            :patient="patient" 
                            v-on:neweventmodal="openNewEventModal"
                            v-on:newevent="openNewEventModal" 
                            v-on:newappointment="setNewAppointmentForm" 
                            v-on:newseizure="newSeizureModal" 
                            v-on:newexam="newExamModal"
                            v-on:editseizure="activateSeizureModal"
                            v-on:appointmentmodal="openAppointmentModal"
                            v-on:eventmodal="openEventModal"
                            v-on:exammodal="openExamModal"
                            v-if="patient._id" ref="unifiedCalendar" />
                        </div>
                        <div role="tabpanel" class="tab-pane" id="tab1">
                          <form class="form">
                            <PatientForm :patient="patient" v-if="patient._id" v-on:updatepatient="updatePatient" ref="ptForm" />
                            <div class="form-actions">
                              <button type="button" class="btn btn-info mr-1" @click.prevent="back()">
                                <i class="fa fa-arrow-left"></i> {{ this.$t("labels.back") }}
                              </button>
                              <button type="button" class="btn btn-success ml-1 mr-1" @click.prevent="updatePatient()">
                                <i class="icon-note"></i> {{ this.$t("labels.save") }}
                              </button>
                              <button type="button" class="btn btn-danger ml-1" @click.prevent="deletePatient()">
                                <i class="icon-close"></i> {{ $t("labels.delete") }}
                              </button>
                            </div>
                          </form>
                        </div>
                        <div class="tab-pane" id="tab3">
                          <template v-if="!therapyForm">
                            <div class="row">
                              <div class="col-md-12">
                                <h4>{{ $t("labels.actualTherapy") }} <button href="#" :disabled="therapyForm || therapyHistoryForm" @click.prevent="editCurrentTherapyDrugs()" class="btn success"><i class="fa fa-pencil font-medium-3"></i></button></h4>
                                <therapy-data :therapy-drugs="patient.currentTherapyDrugs"></therapy-data>
                              </div>
                            </div>
                          </template>  
                          <template v-else>
                            <div class="row">
                              <div class="col-md-12">
                                <h4>{{ $t("labels.actualTherapy") }}</h4>
                              </div>
                            </div>
                            <therapy-drugs-form :patient="patient" 
                                          :therapy-drugs-prop="patient.currentTherapyDrugs"  
                                          v-on:save-therapyDrugs="saveTherapyDrugs"
                                          v-on:cancel-save-therapyDrugs="cancelSaveTherapyDrugs">
                            </therapy-drugs-form>
                          </template>  
                          <template v-if="!therapyHistoryForm">
                            <div class="row">
                              <div class="col-md-12">
                                <h4>{{ $t("labels.therapyHistory") }} <button href="#" :disabled="therapyForm || therapyHistoryForm" @click.prevent="editTherapyDrugsHistory()" class="btn success"><i class="fa fa-pencil font-medium-3"></i></button></h4>
                                <therapy-data :therapy-drugs="patient.therapyDrugsHistory"></therapy-data>
                              </div>
                            </div>
                          </template> 
                          <template v-else>
                            <div class="row">
                              <div class="col-md-12">
                                <h4>{{ $t("labels.therapyHistory") }}</h4>
                              </div>
                            </div>
                            <therapy-drugs-form :patient="patient" 
                                        :therapy-drugs-prop="patient.therapyDrugsHistory"  
                                        v-on:save-therapyDrugs="saveTherapyHistoryDrugs"
                                        v-on:cancel-save-therapyDrugs="cancelSaveTherapyHistoryDrugs">
                            </therapy-drugs-form>
                          </template> 
                        </div>
                        <div class="tab-pane" id="tab5">
                          <medical-exams :patient="patient" v-on:updateexams="updateExams" v-on:deleteexam="deleteExam" v-if="patient._id" ref="examsTab"></medical-exams>
                        </div>
                        <div class="tab-pane" id="tab6">
                          <archive :patient="patient" v-if="patient._id" ref="archive"></archive>
                        </div>
                        <div class="tab-pane" id="tab8">
                          <seizure-graph :patient="patient" :seizures="seizures" v-if="patient._id" ref="graphs"></seizure-graph>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <dev-footer />
    </div>
    <!-- <history-item-edit :item="historyItem" :drugs="drugs" v-on:savehistoryitem="saveItem" ref="historyModal"></history-item-edit> -->
    <seizure-modal :seizure="$store.state.editedSeizure" ref="seizureModal" v-on:updateseizure="updateSeizure" v-on:deleteseizure="deleteSeizure" v-on:imagedeleted="deletedSeizureImage"></seizure-modal>
    <seizure-modal :seizure="newSeizure" id="newSeizureModal" ref="newSeizureModal" v-on:updateseizure="createNewSeizureFromModal"></seizure-modal>
    <event-modal v-on:deleteevent="deleteEvent" v-on:refreshevents="refreshEvents" ref="eventModal" ></event-modal>
    <new-event-modal id="newEventModal" v-on:refreshevents="refreshEvents" ref="newEventModal"></new-event-modal>
    <appointment-modal ref="appointmentModal" v-on:updateappointments="updateAppointments" v-on:updateappointment="updateAppointment" v-on:deleteappointment="deleteAppointment"></appointment-modal>
    <new-appointment-modal id="newAppointmentModal" ref="newAppointmentModal" v-on:updateappointments="updateAppointments" :patient="patient" v-if="patient._id"></new-appointment-modal>
    <new-exam-modal id="newExamModal" ref="newExamModal" v-on:updateexams="updateExams" v-on:updateexamslist="updateExamsList" :patient="patient" v-if="patient._id"></new-exam-modal>
    <exam-modal v-on:deleteexam="deleteExam" v-on:updateexams="updateExams" v-on:updateexamslist="updateExamsList" ref="examModal"></exam-modal>
    <emergency-numbers-modal :patient="patient" v-if="patient.emergencyNumbers && patient.emergencyNumbers.length > 0" ref="emergencyNumbersModal"></emergency-numbers-modal>
  </div>
</template>

<script>
import HistoryItemEdit from '@/components/patient/HistoryItemEdit.vue'
import HistoryItemData from '@/components/patient/HistoryItemData.vue'
import SeizureModal from '@/components/seizure/SeizureModal.vue'
import SeizureForm from '@/components/seizure/SeizureForm.vue'
import EventModal from '@/components/patient/EventModal.vue'
import NewEventModal from '@/components/patient/newEventModal.vue'
import SeizureGraph from '@/components/patient/SeizureGraph.vue'
import UnifiedCalendar from '@/components/patient/UnifiedCalendar.vue'
import PatientService from "../../services/patient"
import SeizureService from '@/services/seizure'
import StorageService from '../../services/storage'
import LovService from '../../services/lov'
import PatientForm from './PatientForm'
import Events from './Events'
import MedicalExams from './MedicalExams.vue'
import AppointmentCalendar from './AppointmentCalendar'
import AppointmentModal from './AppointmentModal'
import NewAppointmentModal from './newAppointmentModal'
import NewExamModal from './newExamModal'
import Archive from './Archive.vue'
import DevFooter from '../DevFooter'
import Progress from '@/components/patient/Progress'
import Swal from 'sweetalert2'
import moment from 'moment'
import downloadCsv from 'vue-json-csv'
import slugify from 'slugify'
import EventService from '@/services/event'
import TherapyData from './TherapyData.vue'
import ExamModal from '@/components/patient/ExamModal.vue'
import GenericModal from '@/components/patient/GenericModal.vue'
import AppointmentService from '@/services/appointment'
import TherapyDrugsService from '@/services/therapyDrugs';
import SizeAndBloodWidget from './SizeAndBloodWidget.vue'
import TherapyDrugsForm from './TherapyDrugsForm.vue';
import EmergencyNumbersModal from './EmergencyNumbersModal.vue';
export default {
  components: {
    PatientForm,
    DevFooter,
    HistoryItemEdit,
    HistoryItemData,
    SeizureModal,
    Events,
    EventModal,
    NewEventModal,
    MedicalExams,
    downloadCsv,
    Progress,
    Archive,
    AppointmentCalendar,
    AppointmentModal,
    NewAppointmentModal,
    NewExamModal,
    SeizureGraph,
    SeizureForm,
    TherapyDrugsForm,
    UnifiedCalendar,
    TherapyData,
    ExamModal,
    GenericModal,
    SizeAndBloodWidget,
    EmergencyNumbersModal
  },
  data: () => {
    return {
      errors: [],
      seizureFormVisibility: false,
      seizureErrors: [],
      events: [],
      patient: {
        actualTherapy: {
          drug: {}
        }
      },
      seizures: [],
      seizure: {
        notes: ``,
        type: {},
        drug: [],
        blockedWithDrugs: false,
        seizureBlocked: false,
        hospitalization: false,
        patiendId: '',
        occuredOn: ''
      },
      newSeizure: {
        notes: ``,
        type: {},
        drug: [],
        blockedWithDrugs: false,
        seizureBlocked: false,
        hospitalization: false,
        patientId: '',
        occuredOn: '',
        modal: true
      },
      newEvent: {
          periodic: false,
          periodStep: 'weeks',
          periodStart: moment(new Date()).startOf('day').format('YYYY-MM-DD'),
          periodEnd: moment(new Date()).add(30, 'days').endOf('day').format('YYYY-MM-DD'),
          dayOfWeek: 1,
          dailyStart: '8:00',
          dailyEnd: '',
          dayType: 'sameday',
          dayOfMonth: 1,
          weekOfMonth: 1,
          dayOfWeek: 1,
          startDate: moment(new Date()).format('YYYY-MM-DD'),
          endDate: null
      },
      seizuresExport: [],
      lovSettings: {},
      historyItem: {},
      drugs: [],
      editedSeizure: {},
      showDate: new Date(),
      therapyForm: false,
      therapyHistoryForm: false,
      intent: '',
      csvLabels: {
        type: 'Type',
        triggeringFactor: 'Triggering factor', 
        occuredOn: 'Occured on', 
        duration: 'Duration', 
        status: 'Status', 
        seizureBlocked: 'Seizure blocked',
        blockedWithDrugs: 'Blocked with drugs', 
        hospitalization: 'Hospitalization',
        drug: 'Drug', 
        notes: 'Notes'
      },
      currentCalendarSelectedDate: null
    }
  },
  computed: {
    csvName() {
      return slugify(`${this.patient.name} ${this.patient.surname} seizures`) + '.csv'
    },
    currentRouteName() {
        return this.$route.name;
    },
    bwd() {
      return this.newSeizure.blockedWithDrugs
    },
    cleanGroupedHistory() {
      if (this.patient && this.patient.groupedHistory)
        return this.patient.groupedHistory[0]
      else
        return []
    }
  },
  watch: {
    bwd() {
      if (this.newSeizure.blockedWithDrugs) {
        if (this.newSeizure.drug.length === 0) {
          let emptyItem = {
            'id': '',
            'name': {},
            'quantity': ''
          }
          this.newSeizure.drug = []
        }
      }
    }
  },
  mounted: async function() {
    let context = this
    let patient
    moment.locale(this.$store.getters.userLang)
    if (this.currentRouteName == "showPatient") {
      patient = await PatientService.byId(this.$route.params.id)
    } else if (this.currentRouteName == 'home') {
      patient = await this.$store.state.patients.find(o => o.default === true)
      if (patient === undefined || patient === null) {
        patient = await PatientService.byId(this.$store.state.patients[0]._id)
      } else {
        patient = await PatientService.byId(patient._id)
      }
    } else {
      patient = await this.$store.state.patients.find(o => o.default === true)
      if (patient === undefined || patient === null) {
        patient = this.$store.state.patients[0]
      } 
    }
    if (patient) {
        if (patient.data) {
          patient = patient.data
        } 
        patient.changeTherapy = false
        patient.heightCm = parseFloat(patient.heightCm)
        patient.weightKg = parseFloat(patient.weightKg)
        this.patient = patient
        this.seizure.patientId = patient._id
        let seizures = await SeizureService.patientSeizures(this.patient._id)
        if (seizures && seizures.data && seizures.data.length > 0) {
          this.seizures = seizures.data
          for (let cs in this.seizures) {
            let current = this.seizures[cs]
            let event = {}
            event.id = current._id
            event.title = current.type && current.type.name ? current.type.name[this.$i18n.locale] : '' 
            event.startDate = moment(new Date(current.occuredOn)).format('YYYY-MM-DD HH:MM:SS')
            this.events.push(event)
          }
          this.formatCsvData()
        }
        let drugs = await LovService.all('drug', false)
        if (drugs) {
          this.drugs = drugs.data
        }
        this.precompiledSeizure()
        console.log(patient)
    } else {
        this.$miniToastr.error(this.$t("flash.failedToLoad"))
    }

    this.$on('showGenericModal', function(selectedDate) {
      context.currentCalendarSelectedDate = selectedDate
    })
   
  },
  methods: {
    back() {
      this.$router.push({ name: 'home'})
    },
    updateExams: async function() {
      await this.$refs.unifiedCalendar.getExams()
    },
    updateExamsList: async function() {
      await this.$refs.examsTab.getExams()
    },
    updateAppointment(appointment) {
      this.$refs.unifiedCalendar.updateAppointment(appointment)
    },
    seizureFormVisibilityControl() {
      this.seizureFormVisibility = true
    },
    newSeizureModal(date){
      console.log('newSeizureModal ',date)
      this.newSeizure.occuredOn = date
      this.newSeizure.patientId = this.patient._id
      $('#newSeizureModal').modal()
    },
    openNewEventModal(tp) {
      this.$refs.newEventModal.getValues(tp)
      $('#newEventModal').modal()
    },
    setNewAppointmentForm(params) {

      this.$refs.newAppointmentModal.appointment.startDate   = moment(new Date(params['appointmentDate'])).startOf('day')
      this.$refs.newAppointmentModal.appointment.endDate     = moment(new Date(params['appointmentDate'])).endOf('day')

      this.$refs.newAppointmentModal.appointment.periodStart = moment(new Date(params['appointmentDate']))
      this.$refs.newAppointmentModal.appointment.periodEnd   = moment(new Date(params['appointmentDate']))
      this.$refs.newAppointmentModal.appointment.dailyStart  = moment(new Date(params['appointmentDate'])).startOf('day')
      this.$refs.newAppointmentModal.appointment.dailyEnd    = moment(new Date(params['appointmentDate'])).endOf('day')
      $('#newAppointmentModal').modal()
    },
    newAppointment(d) {
      this.$refs.newAppointmentModal.appointment.startDate = d
      $('#newAppointmentModal').modal()
    },


    newExamModal(d) {
      this.$refs.newExamModal.exam.date = d
      $('#newExamModal').modal()
    },
    refreshEvents: async function(event) {
      await this.$refs.unifiedCalendar.getEvents('all')
    },
    createNewSeizureFromModal: async function(save_and_continue) {
      await this.createSeizure(this.newSeizure, save_and_continue)
    },
    createSeizure: async function(s, save_and_continue) {
      let seizure
      let self = this
      if (s.modal) {
        seizure = this.newSeizure
      } else {
        seizure = this.seizure
      }
      this.errors = []
      let loader = this.$loading.show({
        color: '#ccc',
        loader: 'spinner'
      },{
        after: this.$createElement('Progress')
      })
      if (!seizure.patientId || seizure.patientId.length === 0) {
        this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("models.patient")]))
      }
      if (!seizure.occuredOn || seizure.occuredOn.length === 0) {
        this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.occuredOn")]))
      }
      if (!seizure.type || seizure.type.length === 0) {
        this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.type")]))
      }
      if (!seizure.duration) {
        this.errors.push(this.$t("errors.validDuration"))
      }
      if (seizure.blockedWithDrugs === true) {
        if (!seizure.drug || seizure.drug.length === 0) {
          this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("models.drug")]))
        }
      }
      if (seizure.video && seizure.video.type) {
        if (!this.$store.state.allowedVideoTypes.includes(seizure.video.type)) {
          this.errors.push(this.$t("errors.wrongFiletype", [seizure.video.name]))
        }
        let videSizeMb = seizure.video.size/1024/1024
        if (videSizeMb > 50 ) {
          this.errors.push(this.$t("errors.tooLarge", [seizure.video.name]))
        }
      }
      if (seizure.uploadImages && Array.isArray(seizure.uploadImages && seizure.uploadImages.length > 0)) {
        _.forEach(seizure.uploadImages, img => {
            if (!this.$store.state.allowedImageTypes.includes(img.type)) {
              this.errors.push(img.name + " has wrong filetype.")
            }
            let imageSizeMb = img.size/1024/1024
            if (imageSizeMb > 5) {
              this.errors.push(this.$t("errors.tooLarge", [img.name]))
            }
        })
      }
      if (this.errors.length === 0) {
        let formData = new FormData()
        formData.append('video', seizure.video)
        _.forEach(seizure.uploadImages, img => {
          formData.append('image', img)
        })
        formData.append('seizure', JSON.stringify(seizure))
        seizure.type = typeof seizure.type === 'string' ? JSON.parse(seizure.type) : seizure.type
        seizure.duration = typeof seizure.duration === 'string' ? JSON.parse(seizure.duration) : seizure.duration
        if (seizure.triggeringFactor) {
          seizure.triggeringFactor = typeof seizure.triggeringFactor === 'string' ? JSON.parse(seizure.triggeringFactor) : seizure.triggeringFactor
        }
        let result = await SeizureService.create(formData)
        if (result.data.success === true) {
          this.$miniToastr.success(this.$t("flash.createSuccess", [this.$t("models.seizure")]))
          let seizures = await SeizureService.patientSeizures(this.patient._id)
          this.seizures = seizures.data
          //this.events = []
          //for (let cs in this.seizures) {
          //  let current = this.seizures[cs]
          //  let event = {}
          //  event.id = current._id
          //  event.title = current.type.name[this.$i18n.locale]
          //  event.startDate = current.occuredOn
          //  this.events.push(event)
          //}
          this.seizure,this.newSeizure = {
            notes: '',
            type: {},
            drug: [],
            duration: {},
            blockedWithDrugs: false,
            seizureBlocked: false,
            hospitalization: false,
            patientId: '',
            occuredOn: '',
            modal: true
          }
          if (seizure.modal == true) {
            if (save_and_continue) {
              $(this.$refs.newSeizureModal.$el).off('hidden.bs.modal').on('hidden.bs.modal', function() {
                setTimeout(function() {
                  self.newSeizureModal(seizure.occuredOn)
                },200)
                $(self.$refs.newSeizureModal.$el).off('hidden.bs.modal')
              })
            }
            this.$refs.newSeizureModal.$refs.closeSeizureModal.click()
            this.$refs.newSeizureModal.$refs.editseizure.resetFiles()
          }
          // this.$refs.newseizure.resetFiles()
          this.$refs.unifiedCalendar.getSeizures()
          if (this.$refs.newseizure != undefined) {
            this.$refs.newseizure.nullifyEditor()
          } else {
            this.$refs.newSeizureModal.$refs.editseizure.nullifyEditor()
          }
          // this.precompiledSeizure()
          this.seizureFormVisibility = false
        } else {
          this.$miniToastr.error(this.$t("flash.createFailed", [this.$t("models.seizure")]))
        }
      } else {
        this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
      }
      loader.hide()
      this.$store.state.currentProgress = 0
    },
    getGraphdata: async function() {
      await this.$refs.graphs.getStatistics()
    },
    updateAppointments: async function() {
      await this.$refs.unifiedCalendar.getAppointments()
    },
    deleteAppointment(appointment) {
      this.$refs.unifiedCalendar.removeAppointment(appointment)
    },
    deletedSeizureImage: async function (img) {
      let result = await SeizureService.deleteImage(this.$store.state.editedSeizure.patientId, this.$store.state.editedSeizure._id, img)
      if (result.data.success) {
        this.$store.state.editedSeizure.image.splice(parseInt(img.index),1)
        this.$miniToastr.success("Image deleted")
      } else {
        this.$miniToastr.error("Failed to delete image on client")
      }
    },
    activateSeizureModal(seizure){
      let current = this.seizures.find(x => x._id === seizure.id)
      if (typeof current.type === 'object') {
        current.type = JSON.stringify(current.type)
      }
      if (typeof current.duration === 'object') {
        current.duration = JSON.stringify(current.duration)
      }
      if (typeof current.triggeringFactor === 'object') {
        current.triggeringFactor = JSON.stringify(current.triggeringFactor)
      }
      current.modal = true
      this.$store.state.editseizure = current
      //console.log(this.$store.state.editedSeizure)
      $('#seizureModal').modal()
    },
    openAppointmentModal(){
      $('#appointmentModal').modal()
    },
    openEventModal(tp, typeValueId){
      this.$refs.eventModal.getValues(tp)
      this.$refs.eventModal.typeId = typeValueId
      $('#eventModal').modal()
    },
    openExamModal(tp, typeValueId) {
      this.$refs.examModal.getValues(tp)
      this.$refs.examModal.typeId = typeValueId
      $('#examModal').modal()
    },
    setShowDate(d) {
      this.showDate = d
    },
    updateSeizure: async function(save_and_continue) {
      let self = this
      let loader = this.$loading.show({
        color: '#ccc',
        loader: 'spinner'
      },{
        after: this.$createElement('Progress')
      })
      //let occuredOn = this.editedSeizure.occuredOnDate + ' ' + this.editedSeizure.occuredOnTime
      //this.editedSeizure.occuredOn = new Date(occuredOn)
      this.$refs.seizureModal.$refs.closeSeizureModal.click()
      this.seizureErrors = []
      const allowedVideoTypes = ['video/mp4','video/x-flv','video/quicktime','video/3gpp','video/x-msvideo','video/x-ms-wmv']
      if (this.$store.state.editedSeizure.video && !Array.isArray(this.$store.state.editedSeizure.video)) {
        if (!allowedVideoTypes.includes(this.$store.state.editedSeizure.video.type)) {
          this.seizureErrors.push(this.$t("errors.wrongFiletype", [this.$store.state.editedSeizure.video.name]))
        }
        let videSizeMb = this.$store.state.editedSeizure.video.size/1024/1024
        if (videSizeMb > 50 ) {
          this.seizureErrors.push(this.$t("errors.tooLarge", [this.$store.state.editedSeizure.video.name]))
        }
      }
      const allowedImageTypes = ['image/jpeg','image/png','image/gif']
      if (this.$store.state.editedSeizure.uploadImages && Array.isArray(this.$store.state.editedSeizure.uploadImages) && this.$store.state.editedSeizure.uploadImages.length > 0) {
        for (let img in this.$store.state.editedSeizure.uploadImages) {
          const allowedImageTypes = ['image/jpeg','image/png','image/gif']  
          if (!allowedImageTypes.includes(this.$store.state.editedSeizure.uploadImages[img].type)) {
            this.seizureErrors.push(this.$t("errors.wrongFiletype", [this.$store.state.editedSeizure.uploadImages[img].name]))
          }
          let imageSizeMb = this.$store.state.editedSeizure.uploadImages[img].size/1024/1024
          if (imageSizeMb > 5) {
            this.seizureErrors.push(this.$t("errors.tooLarge", [this.$store.state.editedSeizure.uploadImages[img].name]))
          }
        }
      }
      if (this.seizureErrors.length === 0) {
        let formData = new FormData()
        formData.append('video', this.$store.state.editedSeizure.video)
        _.forEach(this.$store.state.editedSeizure.uploadImages, img => {
          formData.append('image', img)
        })
        formData.append('seizure', JSON.stringify(this.$store.state.editedSeizure))
        let result = await SeizureService.update(formData)
        if (result) {
          let seizure = result.data.seizure
          /*
          let seizures = await SeizureService.patientSeizures(this.patient._id)
          if (seizures) {
            this.seizures = seizures.data
            this.events = []
            for (let cs in this.seizures) {
              let current = this.seizures[cs]
              let event = {}
              event.id = current._id
              event.title = current.type.name[this.$i18n.locale]
              event.startDate = current.occuredOn
              this.events.push(event)
            }
          }
          */
          // this.$miniToastr.success(this.$t("flash.updateSuccess", ['Seizure']))
          this.$miniToastr.success(this.$t("flash.updateSuccess", [this.$t("models.seizure")]))
          if (save_and_continue) {
            $(this.$refs.seizureModal.$el).off('hidden.bs.modal').on('hidden.bs.modal', function() {
              setTimeout(function() {
                self.newSeizureModal(seizure.occuredOn)
              },200)
              $(self.$refs.seizureModal.$el).off('hidden.bs.modal')
            })
          }
          this.$refs.seizureModal.$refs.closeSeizureModal.click()
          this.$refs.seizureModal.$refs.editseizure.resetFiles()
          this.$refs.newSeizureModal.$refs.editseizure.nullifyEditor()
          this.$refs.unifiedCalendar.getSeizures()
        } else {
          // this.$miniToastr.error(this.$t("flash.updateFailed", ['Seizure']))
          this.$miniToastr.error(this.$t("flash.updateFailed", [this.$t("models.seizure")]))
        }
      } else {
        this.$miniToastr.error(this.seizureErrors.toString().split(",").join("<hr/>"))
        this.seizureErrors = []
      }
      loader.hide()
      this.$store.state.currentProgress = 0
    },
    deleteSeizure: async function() {
      let result = await SeizureService.delete(this.$store.state.editedSeizure)
      if (result) {
        /*
        let seizures = await SeizureService.patientSeizures(this.patient._id)
        if (seizures) {
          this.seizures = seizures.data
          this.events = []
          for (let cs in this.seizures) {
            let current = this.seizures[cs]
            let event = {}
            event.id = current._id
            event.title = current.type.name[this.$i18n.locale]
            event.startDate = current.occuredOn
            this.events.push(event)
          }
        }
        */
        this.$refs.unifiedCalendar.getSeizures()
        this.$miniToastr.success(this.$t("flash.deleteSuccess", [this.$t("models.seizure")]))
        this.$refs.seizureModal.$refs.closeSeizureModal.click()
        this.$refs.unifiedCalendar.removeSeizure(this.$store.state.editedSeizure)
        this.formatCsvData()
      } else {
        this.$miniToastr.error(this.$t("flash.deleteFailed", [this.$t("models.seizure")]))
      }
    },
    deleteEvent: async function(event, wholeItem) {
      // await this.$refs.eventsCalendar.deleteEvent(this.$store.state.eventModalData, wholeItem)
      // await this.$refs.unifiedCalendar.getEvents()
      let result = await EventService.delete(event, wholeItem)
      if (result) {
          this.$refs.unifiedCalendar.removeEvent(this.$store.state.eventModalData,wholeItem)
          this.$miniToastr.success(this.$t("flash.deleteSuccess", [this.$t("models.event")]))
          this.$refs.eventModal.$refs.closeEventModal.click()
      } else {
          this.$miniToastr.error(this.$t("flash.deleteFailed", [this.$t("models.event")]))
      }
    },
    deleteExam(exam) {
      this.$refs.unifiedCalendar.removeExam(exam)
      this.$refs.examsTab.getExams()
    },
    updatePatient: async function() {
        this.errors = []
        if (this.patient.actualTherapy && this.patient.actualTherapy.drugs && this.patient.actualTherapy.drugs.length > 0) {
            this.patient.actualTherapy.drugs.forEach(function(d) {
                d.editMode = false
            })
        }
        if (!this.patient.name || this.patient.name.length == 0) {
          this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.name')]))
        }
        if (!this.patient.surname || this.patient.surname.length == 0) {
          this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.surname')]))
        }
        // console.log(this.$refs.ptForm.sizeIntent)
        
        
        this.$refs.ptForm.sizeForm = false
        const allowedFileTypes = ['application/pdf']
        if (this.patient.certificate && this.patient.certificate.type) {
            if (!allowedFileTypes.includes(this.patient.certificate.type)) {
                this.errors.push(this.$t("errors.wrongFiletype", [this.patient.certificate.name]))
            }
            let certificateSizeMb = this.patient.certificate.size/1024/1024
            if (certificateSizeMb > 5) {
                this.errors.push(this.$t("errors.tooLarge", [this.patient.certificate.name]))
            }
        }
        const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif']
        if (this.patient.avatar && this.patient.avatar.type) {
            if (!allowedImageTypes.includes(this.patient.avatar.type)) {
                this.errors.push(this.$t("errors.wrongFiletype", [this.patient.avatar.name]))
            }
            let avatarSizeMb = this.patient.avatar.size/1024/1024
            if (avatarSizeMb > 5) {
                this.errors.push(this.$t("errors.tooLarge", [this.patient.avatar.name]))
            }
        }
        if (this.errors.length == 0) {
          let formData = new FormData()
          if (this.$refs.ptForm.sizeIntent === 'edit') {
            this.patient.newSize = false
            this.patient.sizeChange = true
            this.$set(this.patient, 'weightKg', this.$refs.ptForm.sizes.weight)
            this.$set(this.patient, 'heightCm', this.$refs.ptForm.sizes.height)
            if (typeof this.$refs.ptForm.sizes.dateOfChangeForEdit == 'object')
              this.$set(this.patient.growthHistory[0], 'dateOfChange', this.$refs.ptForm.sizes.dateOfChangeForEdit.getTime())
            else
              this.$set(this.patient.growthHistory[0], 'dateOfChange', this.$refs.ptForm.sizes.dateOfChangeForEdit)
          }
          debugger
          if (this.$refs.ptForm.sizeIntent === 'new') {
            this.patient.sizeChange = false
            this.patient.newSize = true
            this.$set(this.patient, 'weightKg', this.$refs.ptForm.sizes.weight)
            this.$set(this.patient, 'heightCm', this.$refs.ptForm.sizes.height)
            debugger
            if (typeof this.$refs.ptForm.sizes.dateOfChangeForNew == 'object')
              formData.append('dateOfChangeForNew', this.$refs.ptForm.sizes.dateOfChangeForNew.getTime())
            else
              formData.append('dateOfChangeForNew', this.$refs.ptForm.sizes.dateOfChangeForNew)
          }
          if (this.patient.certificate && this.patient.certificate.type) {
            formData.append('certificate', this.patient.certificate)
          }
          if (this.patient.avatar && this.patient.avatar.type) {
            formData.append('avatar', this.patient.avatar)
          }
          formData.append('patient', JSON.stringify(this.patient))
          const result = await PatientService.update(this.patient._id, formData)
          if (result.data.success === true) {
            result.data.patient.changeTherapy = false
            result.data.patient.heightCm = parseFloat(result.data.patient.heightCm)
            result.data.patient.weightKg = parseFloat(result.data.patient.weightKg)
            this.patient = result.data.patient
            this.$store.dispatch('allPatients')
            // this.$refs.ptForm.setStats()
            this.$miniToastr.success(this.$t("flash.updateSuccess", [this.$t("models.patient")]))
          } else {
            for (let error in result.data.errors) {
              this.errors.push(result.data.errors[error].msg)
            }
            this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
            this.errors = []
          }
        } else {
          this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
          this.errors = []
        }
    },
    setHistoryItem(id) {
      let item = this.patient.therapyHistory.find(x => x.dateOfChange === id)
      console.log(item)
      if (typeof item.drug === 'object') {
        item.drug = JSON.stringify(item.drug)
      }
      this.historyItem = item
    },
    // saveItem: async function() {
    //   let item = this.patient.therapyHistory.find(x => x.dateOfChange === this.historyItem.dateOfChange)
    //   if (typeof item.drug === 'string') {
    //     item.drug = JSON.parse(item.drug)
    //   }
    //   item = this.historyItem
    //   await this.updatePatient()
    //   this.$refs.historyModal.$refs.closeHistoryEditModal.click()
    // },
    back: function() {
      this.$router.push({ name: 'home' })
    },
    deletePatient: async function() {
        let confirmDelete = await Swal.fire({
          title: this.$t("labels.areYouSure"),
          text: this.$t("labels.noRecovery"),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t("labels.confirmDelete"),
          cancelButtonText: this.$t("labels.cancelDelete")
        })
        if (confirmDelete.value) {
           let result = await PatientService.delete(this.patient._id)
            if (result.data.success === true) {
                this.$store.dispatch('allPatients')
                this.$miniToastr.success(this.$t("flash.deleteSuccess", [this.$t("models.patient")]))
                this.$router.push({ name: 'home' })
            } else {
                this.$miniToastr.success(this.$t("flash.deleteFailed", [this.$t("models.patient")]))
            }
        } else {
          Swal.fire(this.$t("labels.confirmCancel"))
        }
    },
    formatCsvData() {
      let formatted = []
      for (let i in this.seizures) {
        let current = {}
        current.type = this.seizures[i].type && this.seizures[i].type.name[this.$i18n.locale] ? this.seizures[i].type.name[this.$i18n.locale] : this.seizures[i].type ? this.seizures[i].type.name['en'] : ''
        current.occuredOn = moment(new Date(this.seizures[i].occuredOn)).format("DD/MM/YYYY")
        current.duration = this.seizures[i].duration && this.seizures[i].duration.name[this.$i18n.locale] ? this.seizures[i].duration.name[this.$i18n.locale] : this.seizures[i].duration && this.seizures[i].duration.name ? this.seizures[i].duration.name['en'] : ''
        current.status = this.seizures[i].status
        current.seizureBlocked = this.seizures[i].seizureBlocked
        current.blockedWithDrugs = this.seizures[i].blockedWithDrugs
        current.hospitalization = this.seizures[i].hospitalization
        if (this.seizures[i].triggeringFactor) {
          current.triggeringFactor = this.seizures[i].triggeringFactor.name[this.$i18n.locale] ? this.seizures[i].triggeringFactor.name[this.$i18n.locale] : this.seizures[i].triggeringFactor.name['en']
        } else {
          current.triggeringFactor = 'None'
        }
        //current.drug = current.blockedWithDrugs ? this.seizures[i].drug.name[this.$i18n.locale] ? this.seizures[i].drug.name[this.$i18n.locale] : this.seizures[i].drug.name['en'] : "-"
        let drugs = ''
        for (let d in this.seizures[i].drug) {
          let item = `${this.seizures[i].drug[d].name && this.seizures[i].drug[d].name[this.$i18n.locale] ? this.seizures[i].drug[d].name[this.$i18n.locale] : this.seizures[i].drug[d].name ? this.seizures[i].drug[d].name['en'] : ''} - ${ this.seizures[i].drug[d].quantity } `
          drugs = drugs + item
        }
        current.drug = drugs
        current.notes = this.seizures[i].notes.replace(/(<([^>]+)>)/ig,"")
        formatted.push(current)
      }
      this.seizuresExport = formatted
    },
    formatDate(d) {
      if (this.$i18n.locale === 'en') {
        return moment(new Date(d)).format("DD/MM/YYYY hh:mm a")
      } else {
        return moment(new Date(d)).format("DD/MM/YYYY HH:mm")
      }
    },
    precompiledSeizure() {
      if (this.seizures.length > 0) {
        if (this.seizure.type) {
          this.seizure.type = JSON.stringify(this.seizures[0].type)  
        }
        this.seizure.duration = this.seizures[0].duration
        this.seizure.status = this.seizures[0].status
        this.seizure.occuredOn = this.seizures[0].occuredOn
        this.seizure.triggeringFactor = JSON.stringify(this.seizures[0].triggeringFactor)
        this.seizure.duration = JSON.stringify(this.seizures[0].duration)
        //this.seizure.blockedWithDrugs = this.selectedPatientSeizures[0].blockedWithDrugs
        //this.seizure.drug = this.selectedPatientSeizures[0].drug
      }
    },
    editCurrentTherapyDrugs: async function() {
      this.therapyForm = !this.therapyForm
    },
    editTherapyDrugsHistory: async function() {
      this.therapyHistoryForm = !this.therapyHistoryForm
    },
    cancelNewTherapy() {
      this.therapyForm = false
      this.patient.newTherapy = false
      this.patient.changeTherapy = false
      this.currentTherapy = {
        drugs: []
      }
    },
    saveTherapyDrugs: async function(payload, ){
      console.log(payload)
      let result = await TherapyDrugsService.createtOrUpdate(this.patient._id, { therapyDrugs: payload })
      this.$miniToastr.success(this.$t("flash.updateSuccess", [this.$t("models.therapy")]))
      this.cancelSaveTherapyDrugs()
    },
    saveTherapyHistoryDrugs: async function(payload, ){
      console.log(payload)
      let result = await TherapyDrugsService.createtOrUpdate(this.patient._id, { therapyDrugs: payload })
      this.$miniToastr.success(this.$t("flash.updateSuccess", [this.$t("models.therapy")]))
      this.cancelSaveTherapyHistoryDrugs()
    },
    cancelSaveTherapyDrugs () {
      this.therapyForm = !this.therapyForm
    },
    cancelSaveTherapyHistoryDrugs () {
      this.therapyHistoryForm = !this.therapyHistoryForm
    },
    // saveTherapy() {
    //   this.errors = []
    //   if (!this.patient.actualTherapy.drugs || this.patient.actualTherapy.length === 0) {
    //     this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.drugs')]))
    //   }
    //   if (!this.patient.actualTherapy.startDate || this.patient.actualTherapy.startDate.length === 0) {
    //     this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.startDate')]))
    //   }
    //   if (this.errors.length === 0) {
    //     // Set intent
    //     if (this.intent === 'edit') {
    //       this.patient.newTherapy = false
    //       this.patient.changeTherapy = true
    //     }
    //     if (this.intent === 'new') {
    //       this.patient.changeTherapy = false
    //       this.patient.newTherapy = true
    //     }
    //     this.therapyForm = false
    //     this.updatePatient()
    //   } else {
    //     this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
    //   }
    // },
    rapidLinkTo: function(destination){
      let that = this;
      switch (destination) {
      case 'homePatient': 
          $('#base-tabX1').click();
          break;
      case 'homeSeizuresList': 
          $('#base-tabX9').click();
          break;
      case 'homeTherapy': 
          $('#base-tabX3').click();
          break;
      case 'homeMedicalExams': 
          $('#base-tabX5').click();
          break;
      case 'homePhotoAndVideo': 
          $('#base-tabX6').click();
          setTimeout(function(){
            that.$refs.archive.$emit('filter-by', process.env.VUE_APP_AUDIO_E_VIDEO_CATEGORY_ID)
          }, 200)
          break;
      case 'homeSeizureGraphs': 
          $('#base-tabX8').click();
          break;
      case 'homeCertificate': 
          $('#base-tabX1').click()
          setTimeout(function(){
            that.scrollToElement($("#emergency-certificate")[0])
          }, 50)
          break;
      case 'homeCalendar': 
           $('#base-tabX9').click();
          break;
      case 'homeTelephone': 
          this.emergencyNumbersModal();
          break;
      case 'homeArchives': 
          $('#base-tabX6').click();
          setTimeout(function(){
            that.$refs.archive.$emit('filter-by', null)
          }, 200)
          break;
      case 'homeNews': 
          this.$router.push({name: 'publicNews'})
          break;
      case 'homeInformation': 
          this.$router.push({name: 'informations'})
          break;
      }
    },
    emergencyNumbersModal: function(){
      $('#emergencyNumbersModal').modal()
    },
    scrollToElement(element) {
      if (element) {
        element.scrollIntoView({behavior: 'smooth'});
      }
    }
  }
};
</script>

<style lang="scss">
  .cv-wrapper.holiday-us-traditional .cv-day-number::before {
    content: "" !important;
  }
  .card .card-header {
    padding-left: 0 !important;
  }
  .collapse-icon.left a:before, .collapse-icon.left a:after {
    left: 0;
  }
  .cv-wrapper div.cv-week {
    min-height: 9em !important;
  }
  .csv-export {
    max-width: 130px;

    button {
      width: 100%;
      height: 100%;
      background-color: #eee;
      border: none;
      padding: 10px;
      box-sizing: border-box;
      transition: all .4s ease;

      &:hover {
        background-color: darken(#eee, 10%)
      }
    }
  }
  .tab-content>.tab-pane {
    height: 1px;
    overflow: hidden;
    display: block;
    visibility: hidden;
  }
  .tab-content>.active {
    height: auto;
    overflow: hidden;
    visibility: visible;
  }
</style>